import { FaEyeSlash, FaRegEye } from "react-icons/fa";
import {
	souBookingIcon,
	cancelBookingIcon,
	addItemIcon,
	bookingSettings,
	packageIcon,
	todayBooking,
	todayVisitor,
	totalBooking,
	upcomingBooking,
	pendingBooking,
	confirmBooking,
	offlineBooking,
	ic_user,
	ic_password,
	specificCancellation,
	userIcon,
	ticketTwoIcon,
	SOUiconTwo,
	teamIcon,
	refundIcon,
	rupeeIcon,
	emailIcon,
	captionIcon,
	bankIcon,
	creditCardIcon,
	accountingIcon,
	salesIcon,
	refundSecondIcon,
	purchaseIcon,
	gstIcon,
	commissionIcon,
	cancelIcon,
	OTPIcon,
	upcomingBookingIcon,
	specificCancelIcon,
	createOrder,
	bookingHistory,
	dailySettlementsIcon,
	watchIcon,
	ic_sou_hotel,
	ic_review,
	blogIcon
} from "../img";
import { formatToINR } from "../Utils/util";

const userDataSignIn = ({
	error,
	email,
	showPass,
	password,
	onShowPassword,
}) => {
	return [
		{
			id: 0,
			error: error.email,
			type: "text",
			field: "email",
			label: "E-mail or User Name",
			placeholder: "Enter E-mail or User Name",
			value: email,
			icon: ic_user,
		},
		{
			id: 1,
			error: error.password,
			type: showPass ? "text" : "password",
			field: "password",
			label: "Password",
			placeholder: "Enter your password",
			value: password,
			icon: ic_password,
			passwordimg: showPass ? <FaRegEye /> : <FaEyeSlash />,
			onShowPassword: onShowPassword,
		},
	];
};

const headerdata = [
	{
		id: 1,
		pathname: "#",
		pagename: "SOU Booking",
		img: <img src={souBookingIcon} alt="SOU Booking" />,
		roles: [1, 2],
		accessKeys: ["sou_attraction_booking", "sou_package_booking"],
		submenu: [
			{
				id: 1,
				pathname: "/attraction-booking/today",
				name: "SOU Attraction",
				otherpaths: [
					"/attraction-booking/today",
					"/attraction-booking/pending",
					"attraction-booking/upcoming",
					"attraction-booking/confirm",
					"attraction-booking/offline",
					"attraction-booking/agent",
					"/attraction-booking/agent",
					"attraction-booking/total",
					"booking/detail",
				],
				accessKeys: ["sou_attraction_booking"],
			},
			// {
			// 	id: 2,
			// 	pathname: '/package-booking/today',
			// 	name: 'SOU Package',
			// 	otherpaths: ["/package-booking/today", "/package-booking/pending", "package-booking/upcoming", "package-booking/confirm", "package-booking/offline", "package-booking/total", "package-booking/detail"],
			// 	accessKeys: ["sou_package_booking"],
			// },
			{
				id: 2,
				pathname: "/rikshaw/e-rikshaw-pending",
				name: "SOU E-rikshaw",
				otherpaths: [
					"/rikshaw/e-rikshaw-pending",
					"/rikshaw/e-rikshaw-today",
					"/rikshaw/e-rikshaw-confirm",
				],
				accessKeys: ["sou_attraction_booking"],
			},
		],
	},
	{
		id: 16,
		pathname: "#",
		pagename: "SOU Hotel",
		img: <img src={ic_sou_hotel} alt="SOU Hotel" />,
		roles: [1, 2],
		accessKeys: [
			"hotel_booking_exchange",
			"hotel_all_booking",
			"hotel_list",
			"hotel_amenities",
			"hotel_facilities",
			"hotel_room_category",
			"hotel_inventory",
			"hotel_settlement_summary",
			"hotel_contact",
		],
		submenu: [
			{
				id: 2,
				pathname: "/hotel/booking",
				name: "All Booking",
				accessKeys: ["hotel_all_booking"],
			},
			{
				id: 3,
				pathname: "/hotel/booking/exchange",
				name: "Booking Exchange",
				accessKeys: ["hotel_booking_exchange"],
			},
			{
				id: 4,
				pathname: "/hotel",
				name: "Hotel List",
				accessKeys: ["hotel_list"],
			},
			{
				id: 8,
				pathname: "/hotel/inventory",
				name: "Hotel Inventory",
				accessKeys: ["hotel_inventory"],
			},
			{
				id: 9,
				pathname: "/hotel/settlement/summary",
				name: "Settlement Summary",
				accessKeys: ["hotel_settlement_summary"],
			},
			{
				id: 11,
				pathname: "/hotel/report/sales-report",
				name: "All report",
				accessKeys: ["hotel_report"],
			},
			{
				id: 100,
				name: "Setting",
				pathname: "#",
				accessKeys: [],
				submenu: [
					{
						id: 101,
						pathname: "/hotel/amenities",
						name: "Amenities",
						accessKeys: ["hotel_amenities"],
					},
					{
						id: 102,
						pathname: "/hotel/facilities",
						name: "Facilities",
						accessKeys: ["hotel_facilities"],
					},
					{
						id: 103,
						pathname: "/hotel/room-category",
						name: "Room Category",
						accessKeys: ["hotel_room_category"],
					},
					{
						id: 104,
						pathname: "/hotel/contact",
						name: "Contact",
						accessKeys: ["hotel_contact"],
					},
				],
			},
		],
	},
	{
		id: 2,
		pathname: "/upcoming_booking?booking_type=upcoming&type=progress",
		pagename: "Upcoming Order",
		img: <img src={upcomingBookingIcon} alt="Upcoming Order" />,
		roles: [1, 2],
		otherpaths: [
			"/upcoming_booking?booking_type=upcoming&type=confirm",
			"/upcoming_booking?booking_type=upcoming&type=reject",
		],
		accessKeys: ["upcoming_orders"],
	},
	{
		id: 3,
		pathname: "",
		pagename: "Cancel Booking",
		img: <img src={cancelBookingIcon} alt="Cancel Booking" />,
		roles: [1, 2],
		accessKeys: ["cancel_booking"],
		submenu: [
			{
				id: 1,
				pathname: "/cancel_booking?booking_type=cancel_attraction&type=cancel",
				name: "Attraction Cancel",
				otherpaths: [
					"/cancel_booking?booking_type=cancel_attraction&type=cancelConfirm",
					"sou-booking-cancel",
					"booking-cancel-confirm",
				],
				accessKeys: ["cancel_booking"],
			},
		],
	},
	{
		id: 4,
		pagename: "Specific Cancel",
		img: <img src={specificCancelIcon} alt="Specific Cancel" />,
		roles: [1, 2],
		accessKeys: ["specific_cancel_booking"],
		submenu: [
			{
				id: 1,
				pathname:
					"/cancel_booking?booking_type=specific_cancel_attraction&type=cancel",
				name: "Attraction Cancel",
				otherpaths: [
					"/cancel_booking?booking_type=specific_cancel_attraction&type=cancelConfirm",
					"sou-booking-cancel",
					"booking-specific-cancel-confirm",
				],
				accessKeys: ["specific_cancel_booking"],
			},
		],
	},
	{
		id: 5,
		pathname: "",
		pagename: "Refund Booking",
		img: <img src={refundIcon} alt="Refund Booking" />,
		roles: [1, 2],
		accessKeys: ["refund_booking", "hotel_refund"],
		submenu: [
			{
				id: 1,
				pathname: "/refund_booking?booking_type=refund_attraction&type=refund",
				name: "Attraction Refund",
				otherpaths: [
					"/refund_booking?booking_type=refund_attraction&type=refundConfirm",
					"sou-booking-refund",
					"booking-refund-confirm",
				],
				accessKeys: ["refund_booking"],
			},
			{
				id: 3,
				pathname: "/refund_booking?booking_type=refund_specific&type=refund",
				name: "Specific Refund",
				otherpaths: [
					"/refund_booking?booking_type=refund_specific&type=refundConfirm",
					"booking-specific-refund",
					"booking-specific-refund-confirm",
				],
				accessKeys: ["refund_booking"],
			},
			{
				id: 4,
				pathname: "/hotel/booking/refund-pending",
				name: "Hotel Refund",
				accessKeys: ["hotel_refund"],
			},
		],
	},
	{
		id: 6,
		pathname: "",
		pagename: "Booking History",
		img: <img src={bookingHistory} alt="Refund Booking" />,
		roles: [1, 2],
		accessKeys: ["booking_history"],
		submenu: [
			{
				id: 1,
				pathname: "/attraction-booking-history/all",
				name: "SOU Attraction",
				otherpaths: [
					"/attraction-booking-history/all",
					"/attraction-booking-history/pending",
					"attraction-booking-history/confirm",
					"attraction-booking-history/offline",
					"attraction-booking-history/agent",
					"/attraction-booking-history/agent",
					"attraction-booking-history/cancel",
					"attraction-booking-history/specific-cancel",
					"attraction-booking-history/refund",
				],
				accessKeys: ["booking_history"],
			},
			{
				id: 2,
				pathname: "/reports/attraction",
				name: "Attraction Report",
				accessKeys: ["booking_history"],
			},
			{
				id: 3,
				pathname: "/hotel/booking-history",
				name: "SOU Hotel",
				accessKeys: ["hotel_all_booking"],
			},
			{
				id: 4,
				pathname: "/booking-for-review",
				name: "Booking For Review",
				accessKeys: ["booking_history"],
			},
			{
				id: 5,
				pathname: "/other-sou-booking",
				name: "Other SOU Booking",
				accessKeys: ["sou_attraction_booking"],
			},
			{
				id: 6,
				pathname: "/attraction-booking-history/archive",
				name: "Booking Archive",
				otherpaths: [
					"/attraction-booking-history/archive"
				],
				accessKeys: ["booking_history"],
			},
		],
	},
	{
		id: 7,
		pathname: "#",
		pagename: "Add Item",
		img: <img src={addItemIcon} alt="Add item" />,
		roles: [1, 2],
		accessKeys: ["add_item"],
		submenu: [
			{
				id: 1,
				pathname: "/tourist-places",
				name: "Add Attraction",
				otherpaths: [
					"/create-place",
					"/update-place",
					"place/on",
					"place/off",
					"off-place",
				],
				accessKeys: ["add_item"],
			},
			{
				id: 2,
				pathname: "/package",
				name: "Add Package",
				otherpaths: [
					"/create-package",
					"/update-package",
					"/package/category",
					"/create-category",
					"/update-category",
				],
				accessKeys: ["add_item"],
			},
			{
				id: 3,
				pathname: "/optional-attractions",
				name: "Optional Attraction",
				otherpaths: [
					"/create-optional-attraction",
					"/update-optional-attraction",
				],
				accessKeys: ["add_item"],
			},
		],
	},
	{
		id: 8,
		pathname: "/quotations/pending",
		pagename: "Create Order",
		img: <img src={createOrder} alt="Create Order" />,
		roles: [1],
		otherpaths: [
			"/quotations/confirm",
			"/quotations/reject",
			"/quotation/create",
			"/quotation/add-visitors",
			"/quotation/action",
		],
		accessKeys: ["create_order"],
	},
	{
		id: 9,
		pathname: "#",
		pagename: "Team",
		img: <img src={teamIcon} alt="Team" />,
		roles: [1, 2],
		accessKeys: [
			"team_member",
			"bank_access",
			"emp_attendance",
			"number_access",
		],
		submenu: [
			{
				id: 1,
				pathname: "/team",
				name: "Team Member",
				otherpaths: ["/create-member", "/update-member"],
				accessKeys: ["team_member"],
			},
			{
				id: 2,
				pathname: "/team/attendance",
				name: "Emp. Attendance",
				otherpaths: ["/team/summary-report"],
				accessKeys: ["emp_attendance"],
			},
			{
				id: 3,
				pathname: "/team/bank-access",
				name: "Bank Access",
				accessKeys: ["bank_access"],
			},
			{
				id: 4,
				pathname: "/team/number-access",
				name: "Number Access",
				accessKeys: ["number_access"],
			},
			{
				id: 5,
				pathname: "/team/report",
				name: "Team Report",
				otherpaths: ["/team/report/"],
			},
			{
				id: 6,
				pathname: "/security/devices",
				name: "Office Devices",
				otherpaths: ["/security/devices"],
			},
			{
				id: 7,
				pathname: "/security/active-staff",
				name: "Active Staff",
				otherpaths: ["/security/active-staff"],
			},
			{
				id: 8,
				pathname: "/security/login-logs",
				name: "Login Logs",
				otherpaths: ["/security/login-logs"],
			},
		],
	},
	{
		id: 17,
		pathname: "#",
		pagename: "Agent",
		img: <img src={teamIcon} alt="Agent" />,
		roles: [1, 2],
		accessKeys: ["agent_management"],
		submenu: [
			{
				id: 1,
				pathname: "/agent/dashboard",
				name: "Agent Dashboard",
				otherpaths: ["/agent/dashboard"],
				accessKeys: ["agent_management"],
			},
			{
				id: 2,
				pathname: "/agent/list",
				name: "All Agents",
				otherpaths: ["/agent/list", "/agent/view", "/agent/edit"],
				accessKeys: ["agent_management"],
			},
			{
				id: 3,
				pathname: "/agent/create",
				name: "Create Agent",
				otherpaths: ["/agent/create"],
				accessKeys: ["agent_management"],
			},
		],
	},
	{
		id: 10,
		pathname: "#",
		pagename: "Accounting",
		img: <img src={accountingIcon} alt="Accounting" />,
		roles: [1],
		accessKeys: ["accounting"],
		submenu: [
			{
				id: 1,
				pathname: "/accounting/bank-account",
				name: "Accounts",
				otherpaths: ["/accounting/credit-card"],
				accessKeys: ["accounting"],
			},
			{
				id: 2,
				pathname: "/accounting/staff-debit-note",
				name: "Staff Debit Note",
				accessKeys: ["accounting"],
			},
			{
				id: 3,
				pathname: "/accounting/staff-credit-note",
				name: "Staff Credit Note",
				accessKeys: ["accounting"],
			},
			{
				id: 4,
				pathname: "/accounting/bank-transfer",
				name: "Bank Transfer",
				accessKeys: ["accounting"],
			},
			{
				id: 5,
				pathname: "/accounting/auto-entry-settings",
				name: "Auto Entry Settings",
				accessKeys: ["accounting"],
			}
		],
	},
	{
		id: 18,
		pathname: "#",
		pagename: "Reports",
		img: <img src={accountingIcon} alt="Reports" />,
		roles: [1],
		accessKeys: ["report"],
		submenu: [
			{
				id: 1,
				pathname: "/reports/sales",
				name: "Sales",
				accessKeys: ["report"],
			},
			{
				id: 2,
				pathname: "/reports/purchase",
				name: "Purchase",
				accessKeys: ["report"],
			},
			{
				id: 4,
				pathname: "/reports/commission",
				name: "Commission",
				accessKeys: ["report"],
			},
			{
				id: 5,
				pathname: "/reports/cancel",
				name: "Cancel",
				accessKeys: ["report"],
			},
			{
				id: 6,
				pathname: "/reports/gst",
				name: "GST",
				accessKeys: ["report"],
			},
			// {
			// 	id: 4,
			// 	pathname: '/accounting/reports/sales/attraction',
			// 	name: 'Reports',
			// 	otherpaths: ["/accounting/reports/purchase/attraction", "/accounting/reports/commission", "/accounting/reports/gst", "/accounting/reports/cancel", "/accounting/reports/refund"],
			// 	accessKeys: ["accounting"],
			// }
		],
	},
	{
		id: 11,
		pathname: "/payment-history",
		pagename: "Payment History",
		img: <img src={accountingIcon} alt="Accounting" />,
		roles: [1],
		accessKeys: ["payment_report"],
		otherpaths: ["/daily-ledger-report"],
	},
	{
		id: 12,
		pagename: "Daily Settlements",
		img: <img src={dailySettlementsIcon} alt="Accounting" />,
		roles: [1],
		accessKeys: ["daily_settlements"],
		submenu: [
			{
				id: 1,
				pathname: "/accounting/reports/settlement",
				name: "Daily Settlements",
			},
			{
				id: 2,
				pathname: "/accounting/reports/settlement-history",
				name: "Settlement History",
			},
			{
				id: 3,
				pathname: "/accounting/reports/pending-settlement",
				name: "Pendding Settlement",
			},
		]
	},
	{
		id: 13,
		pathname: "/assign-account/bank",
		pagename: "Bank Details",
		img: <img src={accountingIcon} alt="Bank Details" />,
		roles: [1, 2],
	},
	{
		id: 20,
		pathname: "/bank-account/access",
		pagename: "Bank Reports",
		img: <img src={accountingIcon} alt="Bank Access" />,
		roles: [1, 2],
	},
	{
		id: 14,
		pathname: "/sou-otp-number",
		pagename: "SOU OTP No.",
		img: <img src={OTPIcon} alt="Accounting" />,
		roles: [1, 2],
	},
	{
		id: 15,
		pathname: "/enquiry/pending",
		pagename: "Enquiry",
		img: <img src={teamIcon} alt="Enquiry Icon" />,
		roles: [1, 2],
		otherpaths: ["/enquiry/confirm"],
		accessKeys: ["enquiry"],
	},
	{
		id: 17,
		pathname: "/testimonials",
		pagename: "Testimonial",
		img: <img src={ic_review} alt="Enquiry Icon" />,
		roles: [1],
		accessKeys: ["testimonials"],
	},
	{
		id: 18,
		pathname: "/sitemap/list",
		pagename: "Sitemap",
		img: <img src={addItemIcon} alt="Sitemap Icon" />,
		roles: [1],
		accessKeys: ["sitemap"],
	},
	{
		id: 19,
		pathname: "#",
		pagename: "Blog",
		img: <img src={blogIcon} alt="Blog" />,
		roles: [1, 2],
		accessKeys: ["blog_management"],
		submenu: [
			{
				id: 1,
				pathname: "/blog/category",
				name: "Category",
				otherpaths: ["/blog/create-category", "/blog/update-category"],
				accessKeys: ["blog_management"],
			},
			{
				id: 2,
				pathname: "/blog/list",
				name: "Blog",
				otherpaths: ["/blog/create-blog", "/blog/update-blog"],
				accessKeys: ["blog_management"],
			},
		],
	},
];

const addPlace = ({ error, formData }) => {
	return [
		{
			id: 1,
			error: error?.name,
			field: "name",
			type: "text",
			placeholder: "Place Name",
			value: formData?.name,
		},
		{
			id: 2,
			error: error?.shortDescription,
			field: "shortDescription",
			type: "textarea",
			placeholder: "Short Description",
			value: formData?.shortDescription,
		},
		{
			id: 4,
			error: error?.description,
			field: "description",
			type: "textarea",
			placeholder: "Description",
			value: formData?.description,
		},
		{
			id: 5,
			error: error?.openingTime,
			field: "openingTime",
			type: "text",
			placeholder: "openingTime",
			value: formData?.openingTime,
		},
		{
			id: 6,
			error: error?.closingTime,
			field: "closingTime",
			type: "text",
			placeholder: "closingTime",
			value: formData?.closingTime,
		},
		{
			id: 7,
			error: error?.timeTakeToVisit,
			field: "timeTakeToVisit",
			type: "text",
			placeholder: "timeTakeToVisit",
			value: formData?.timeTakeToVisit,
		},
		{
			id: 8,
			error: error?.chargesForAdult,
			field: "chargesForAdult",
			type: "number",
			placeholder: "chargesForAdult",
			value: formData?.chargesForAdult,
		},
		{
			id: 9,
			error: error?.chargesForAdult,
			field: "chargesForAdult",
			type: "number",
			placeholder: "chargesForAdult",
			value: formData?.chargesForAdult,
		},
		{
			id: 10,
			error: error?.closingDay,
			field: "closingDay",
			type: "select",
			placeholder: "closingDay",
			value: formData?.closingDay,
			options: [
				{ value: "monday", label: "Monday" },
				{ value: "tuesday", label: "Tuesday" },
				{ value: "wednesday", label: "Wednesday" },
				{ value: "thursday", label: "Thursday" },
				{ value: "friday", label: "Friday" },
				{ value: "saturday", label: "Saturday" },
				{ value: "sunday", label: "Sunday" },
			],
		},
		{
			id: 11,
			error: error?.sloteName,
			field: "sloteName",
			type: "text",
			placeholder: "sloteName",
			value: formData?.sloteName,
		},
		{
			id: 12,
			error: error?.placeKey,
			field: "placeKey",
			type: "text",
			placeholder: "placeKey",
			value: formData?.placeKey,
		},
		{
			id: 13,
			error: error?.attractionIncluded,
			field: "attractionIncluded",
			type: "text",
			placeholder: "attractionIncluded",
			value: formData?.attractionIncluded,
		},
		{
			id: 14,
			error: error?.isBookingOn,
			field: "isBookingOn",
			type: "number",
			placeholder: "isBookingOn",
			value: formData?.isBookingOn,
		},
		{
			id: 15,
			error: error?.childAgeFrom,
			field: "childAgeFrom",
			type: "number",
			placeholder: "childAgeFrom",
			value: formData?.childAgeFrom,
		},
		{
			id: 16,
			error: error?.childAgeTo,
			field: "childAgeTo",
			type: "number",
			placeholder: "childAgeTo",
			value: formData?.childAgeTo,
		},
		{
			id: 17,
			error: error?.adultAgeFrom,
			field: "adultAgeFrom",
			type: "number",
			placeholder: "adultAgeFrom",
			value: formData?.adultAgeFrom,
		},
		{
			id: 18,
			error: error?.isEnableForSalesPerson,
			field: "isEnableForSalesPerson",
			type: "number",
			placeholder: "isEnableForSalesPerson",
			value: formData?.isEnableForSalesPerson,
		},
		{
			id: 19,
			error: error?.adultSalesCommission,
			field: "adultSalesCommission",
			type: "number",
			placeholder: "adultSalesCommission",
			value: formData?.adultSalesCommission,
		},
		{
			id: 20,
			error: error?.childSalesCommission,
			field: "childSalesCommission",
			type: "number",
			placeholder: "childSalesCommission",
			value: formData?.childSalesCommission,
		},
		{
			id: 21,
			error: error?.bookingClosingTime,
			field: "bookingClosingTime",
			type: "number",
			placeholder: "bookingClosingTime",
			value: formData?.bookingClosingTime,
		},
		{
			id: 22,
			error: error?.status,
			field: "status",
			type: "select",
			placeholder: "status",
			value: formData.status,
			options: [
				{ value: "active", label: "Active" },
				{ value: "inactive", label: "inactive" },
			],
		},
		{
			id: 3,
			error: error?.image,
			field: "image",
			type: "file",
			placeholder: "image",
			value: formData?.image,
		},
	];
};

const bookingOnOff = [
	{
		pathname: "/place/on",
		pageName: "Booking On",
		image: bookingSettings,
	},
	{
		pathname: "/place/off",
		pageName: "Booking Off",
		image: bookingSettings,
	},
];

const placeOnOff = [
	{
		pathname: "/off-place",
		pageName: "Booking Off",
		image: bookingSettings,
	},
];

const packageMenu = [
	{
		pathname: "/package",
		pageName: "Package",
		image: packageIcon,
	},
	{
		pathname: "/package/category",
		pageName: "Package Category",
		image: packageIcon,
	},
];

const bookingMenu = [
	{
		pathname: "/attraction-booking/today",
		pageName: "Today Booking",
		image: todayBooking,
	},
	{
		pathname: "/attraction-booking/pending",
		pageName: "Pending Booking",
		image: pendingBooking,
	},
	{
		pathname: "/attraction-booking/upcoming",
		pageName: "Upcoming Booking",
		image: upcomingBooking,
	},
	{
		pathname: "/attraction-booking/confirm",
		pageName: "Confirm Booking",
		image: confirmBooking,
	},
	{
		pathname: "/attraction-booking/offline",
		pageName: "Offline Booking",
		image: offlineBooking,
	},
	{
		pathname: "/attraction-booking/agent",
		pageName: "Agent",
		image: userIcon,
	},
	{
		pathname: "/attraction-booking/total",
		pageName: "Total Booking",
		image: totalBooking,
	},
	{
		pathname: "/attraction-booking/today-visitors",
		pageName: "Today Visitors",
		image: todayVisitor,
	},
];

const packageBookingMenu = [
	{
		pathname: "/package-booking/today",
		pageName: "Today Booking",
		image: todayBooking,
	},
	{
		pathname: "/package-booking/pending",
		pageName: "Pending Booking",
		image: pendingBooking,
	},
	{
		pathname: "/package-booking/upcoming",
		pageName: "Upcoming Booking",
		image: upcomingBooking,
	},
	{
		pathname: "/package-booking/confirm",
		pageName: "Confirm Booking",
		image: confirmBooking,
	},
	{
		pathname: "/package-booking/offline",
		pageName: "Offline Booking",
		image: offlineBooking,
	},
	{
		pathname: "/package-booking/total",
		pageName: "Total Booking",
		image: totalBooking,
	},
	{
		pathname: "/package-booking/today-visitors",
		pageName: "Today Visitors",
		image: todayVisitor,
	},
];

const bookingDetailMenu = [
	{
		pathname: "/booking/detail",
		pageName: "User Detail",
		image: userIcon,
	},
	{
		pathname: "/booking/confirm",
		pageName: "Confirm Ticket",
		image: ticketTwoIcon,
	},
	{
		pathname: "/booking/sou-ticket",
		pageName: "SOU Ticket",
		image: SOUiconTwo,
	},
	{
		pathname: "/booking/specific-cancellation",
		pageName: "Specific Cancellation",
		image: specificCancellation,
	},
	{
		pathname: "/booking/booking-cancel",
		pageName: "Booking Cancel",
		image: SOUiconTwo,
	},
];

const siteSettingMenu = [
	{
		pathname: "/setting/site-settings",
		pageName: "Site Settings",
		image: SOUiconTwo,
	},
	{
		pathname: "/setting/service-charge",
		pageName: "Service Charge",
		image: SOUiconTwo,
	},
	{
		pathname: "/setting/home-page-banner",
		pageName: "Home Page Banner",
		image: SOUiconTwo,
	},
	{
		pathname: "/setting/home-page-places",
		pageName: "Home Page Places",
		image: SOUiconTwo,
	},
	{
		pathname: "/setting/sou-phone-number",
		pageName: "SOU Phone Number",
		image: SOUiconTwo,
	},
	{
		pathname: "/setting/home-note",
		pageName: "Home Page Note",
		image: SOUiconTwo,
	},
	{
		pathname: "/setting/place-key",
		pageName: "Place Keys",
		image: SOUiconTwo,
	},
	{
		pathname: "/setting/faqs",
		pageName: "General FAQs",
		image: SOUiconTwo,
	},
	{
		pathname: "/setting/hotel",
		pageName: "Hotel Settings",
		image: SOUiconTwo,
	},
	{
		pathname: "/setting/hotel-admin",
		pageName: "Hotel Admin Settings",
		image: SOUiconTwo,
	},
	// {
	// 	pathname: "/setting/home-page-packages",
	// 	pageName: "Home Page Packages",
	// 	image: SOUiconTwo,
	// }
];

const galleryMenu = [
	{
		pathname: "/place/images",
		pageName: "Images",
		image: SOUiconTwo,
	},
	{
		pathname: "/place/videos",
		pageName: "Videos",
		image: SOUiconTwo,
	},
	{
		pathname: "/place/reels",
		pageName: "Reels",
		image: SOUiconTwo,
	},
];

const confirmTicketForm = ({ error, formData }) => {
	return [
		{
			id: 1,
			error: error?.souLoginNumber,
			field: "souLoginNumber",
			type: "text",
			placeholder: "SOU Mobile Login Number",
			label: "SOU Mobile Login Number",
			value: formData?.souLoginNumber,
			required: true,
			readOnly: true,
		},
		{
			id: 2,
			error: error?.bookingReferenceNumber,
			field: "bookingReferenceNumber",
			type: "text",
			placeholder: "Booking Reference Number",
			label: "* Booking Reference Number",
			value: formData?.bookingReferenceNumber,
			required: true,
		},
	];
};

const refundForm = ({ error, formData }) => {
	return [
		{
			id: 1,
			error: error?.amount,
			field: "amount",
			type: "text",
			placeholder: "Enter Refund Amount",
			label: "* Refund Amount",
			value: formData?.amount,
			required: true,
		},
		{
			id: 2,
			error: error?.refundReason,
			field: "refundReason",
			type: "textarea",
			placeholder: "Enter Refund Reason",
			label: "* Cancel Note",
			value: formData?.refundReason,
			required: true,
		},
		{
			id: 3,
			error: error?.bankDetail,
			field: "bankDetail",
			type: "textarea",
			placeholder: "Enter Bank Detail/UPI Id",
			label: "* Bank Detail/UPI Id",
			value: formData?.bankDetail,
			required: true,
		},
	];
};

const addMemberForm = ({ error, formData }) => {
	return [
		{
			id: 1,
			error: error?.firstName,
			field: "firstName",
			type: "text",
			placeholder: "Enter Employee Name",
			label: "Employee Name",
			value: formData?.firstName,
			required: true,
		},
		{
			id: 2,
			error: error?.email,
			field: "email",
			type: "text",
			placeholder: "Enter Email ID",
			label: "Email ID",
			value: formData?.email,
			required: true,
			icon: emailIcon,
		},
		{
			id: 3,
			error: error?.username,
			field: "username",
			type: "text",
			placeholder: "Enter User Name",
			label: "User Name",
			value: formData?.username,
			required: true,
			icon: emailIcon,
		},
		{
			id: 4,
			error: error?.passwordString,
			field: "passwordString",
			type: "text",
			placeholder: "Enter password",
			label: "Password",
			value: formData?.passwordString,
			required: true,
		},
		{
			id: 5,
			error: error?.employeeId,
			field: "employeeId",
			type: "text",
			placeholder: "Enter Employee ID",
			label: "Employee ID",
			value: formData?.employeeId,
			required: true,
		},
		{
			id: 6,
			error: error?.phoneNo,
			field: "phoneNo",
			type: "text",
			placeholder: "Enter login number",
			label: "Login Number",
			value: formData?.phoneNo,
			required: true,
		},
		{
			id: 13,
			error: error?.contactNumber,
			field: "contactNumber",
			type: "text",
			placeholder: "Enter contact number",
			label: "Contact Number",
			value: formData?.contactNumber,
			required: true,
		},
		{
			id: 14,
			error: error?.fatherNumber,
			field: "fatherNumber",
			type: "text",
			placeholder: "Enter father contact number",
			label: "Father Contact Number",
			value: formData?.fatherNumber,
			required: true,
		},
		{
			id: 7,
			error: error?.joiningDate,
			field: "joiningDate",
			type: "datepicker",
			placeholder: "DD-MM-YYYY",
			label: "Joining Date",
			value: formData?.joiningDate,
			required: true,
			icon: captionIcon,
		},
		{
			id: 8,
			error: error?.designation,
			field: "designation",
			type: "text",
			placeholder: "Select designation",
			label: "Designation",
			value: formData?.designation,
			required: true,
		},
		{
			id: 9,
			error: error?.monthlyPay,
			field: "monthlyPay",
			type: "text",
			placeholder: "Enter Amount",
			label: "Monthly Pay",
			value: formData?.monthlyPay,
			required: true,
			icon: rupeeIcon,
		},
		{
			id: 10,
			error: error?.address,
			field: "address",
			type: "textarea",
			placeholder: "Enter Employee address",
			label: "Address",
			value: formData?.address,
			required: true,
		},
		{
			id: 11,
			error: error?.loginTime,
			field: "loginTime",
			type: "timepicker",
			placeholder: "Select Login Time",
			label: "Login Time",
			value: formData?.loginTime,
			required: false,
			icon: watchIcon,
		},
		{
			id: 12,
			error: error?.logoutTime,
			field: "logoutTime",
			type: "timepicker",
			placeholder: "Select Logout Time",
			label: "Logout Time",
			value: formData?.logoutTime,
			required: false,
			icon: watchIcon,
		},
	];
};

const cancelBookingMenu = [
	{
		pathname: "/cancel_booking?booking_type=cancel_attraction&type=cancel",
		pageName: "Cancel",
		image: pendingBooking,
	},
	{
		pathname: "/cancel_booking?booking_type=cancel_attraction&type=cancelConfirm",
		pageName: "Cancel Confirm",
		image: todayBooking,
	},
];

const cancelPackageBookingMenu = [
	{
		pathname: "/cancel_booking?booking_type=cancel_package&type=cancel",
		pageName: "Cancel",
		image: pendingBooking,
	},
	{
		pathname: "/cancel_booking?booking_type=cancel_package&type=cancelConfirm",
		pageName: "Cancel Confirm",
		image: todayBooking,
	},
];

const refundBookingMenu = [
	{
		pathname: "/refund_booking?booking_type=refund_attraction&type=refund",
		pageName: "Refund Pending",
		image: pendingBooking,
	},
	{
		pathname:
			"/refund_booking?booking_type=refund_attraction&type=today_refund",
		pageName: "Today Refund",
		image: pendingBooking,
	},
	{
		pathname:
			"/refund_booking?booking_type=refund_attraction&type=refundConfirm",
		pageName: "Refunded",
		image: todayBooking,
	},
];

const refundPackageBookingMenu = [
	{
		pathname: "/refund_booking?booking_type=refund_package&type=refund",
		pageName: "Refund Pending",
		image: pendingBooking,
	},
	{
		pathname: "/refund_booking?booking_type=refund_package&type=refundConfirm",
		pageName: "Refunded",
		image: todayBooking,
	},
];

const specificRefundBookingMenu = [
	{
		pathname: "/refund_booking?booking_type=refund_specific&type=refund",
		pageName: "Refund Pending",
		image: pendingBooking,
	},
	{
		pathname: "/refund_booking?booking_type=refund_specific&type=refundConfirm",
		pageName: "Refunded",
		image: todayBooking,
	},
];

const refundBookingForm = ({ error, formData, bankAccounts }) => {
	return [
		{
			id: 1,
			error: error?.refundableAmount,
			field: "refundableAmount",
			type: "text",
			placeholder: "Enter Refund Amount",
			label: "* Refund Amount",
			value: formData?.refundableAmount,
			required: true,
		},
		{
			id: 4,
			error: error?.accountId,
			field: "accountId",
			type: "select",
			placeholder: "",
			label: "* Refund From Account",
			value: formData?.accountId,
			required: true,
			options: [
				{ value: "", label: "Select Bank" },
				...(bankAccounts?.length > 0
					? bankAccounts.map((item) => ({
						value: item._id,
						label: item.bankName,
					}))
					: []),
			],
		},
		{
			id: 2,
			error: error?.refundReason,
			field: "refundReason",
			type: "textarea",
			placeholder: "Enter Refund Reason",
			label: `* Refund Reason (${formData?.cancelBy ? 'Cancel By User' : 'Cancel By Admin'})`,
			value: formData?.refundReason,
			required: true,
		},
		{
			id: 3,
			error: error?.bankDetail,
			field: "bankDetail",
			type: "textarea",
			placeholder: "Enter Bank Detail/UPI Id",
			label: "* Bank Detail/UPI Id",
			value: formData?.bankDetail,
			required: true,
		},
	];
};

const attendanceForm = ({ error, formData, teamOptions }) => {
	return [
		{
			id: 1,
			error: error?.attendanceDate,
			field: "attendanceDate",
			type: "datepicker",
			placeholder: "DD-MM-YYYY",
			label: "Select Date",
			value: formData?.attendanceDate,
			required: true,
			icon: captionIcon,
		},
		{
			id: 2,
			error: error?.staffId,
			field: "staffId",
			type: "select",
			placeholder: "staffId",
			value: formData?.staffId,
			label: "Select Employee",
			options: teamOptions,
			required: true,
		},
		{
			id: 3,
			error: error?.attendanceType,
			field: "attendanceType",
			type: "select",
			placeholder: "attendanceType",
			label: "Attendance",
			value: formData?.attendanceType,
			options: [
				{ value: "present", label: "Present" },
				{ value: "absent", label: "Absent" },
				{ value: "halfday", label: "Halfday" },
				{ value: "holiday", label: "Holiday" },
			],
			required: true,
		},
	];
};

const accountMenu = [
	{
		pathname: "/accounting/bank-account",
		pageName: "Bank Account",
		image: bankIcon,
	},
	{
		pathname: "/accounting/credit-card",
		pageName: "Credit Card",
		image: creditCardIcon,
	},
];

const tallyMenu = [
	{
		pathname: "/accounting/tally/main-group",
		pageName: "Main Group",
		image: bankIcon,
	},
	{
		pathname: "/accounting/tally/sub-group",
		pageName: "Sub Group",
		image: bankIcon,
	},
	{
		pathname: "/accounting/tally/ledger",
		pageName: "Ledger",
		image: bankIcon,
	},
	{
		pathname: "/accounting/tally/balance-sheet",
		pageName: "Balance Sheet",
		image: bankIcon,
	},
	{
		pathname: "/accounting/tally/profit-loss",
		pageName: "Profit & Loss",
		image: bankIcon,
	},
];

const bankAccountForm = ({ error, formData, ledgerOptions }) => {
	return [
		{
			id: 1,
			error: error?.accountName,
			field: "accountName",
			type: "text",
			placeholder: "Enter Bank Holder Name",
			label: "* Account Name",
			value: formData?.accountName,
			required: true,
		},
		{
			id: 2,
			error: error?.mobileNumber,
			field: "mobileNumber",
			type: "text",
			placeholder: "Enter Mobile Number",
			label: "* Mobile Number",
			value: formData?.mobileNumber,
			required: true,
		},
		{
			id: 3,
			error: error?.bankName,
			field: "bankName",
			type: "text",
			placeholder: "Enter Bank Name",
			label: "* Bank Name",
			value: formData?.bankName,
			required: true,
		},
		{
			id: 4,
			error: error?.ifscCode,
			field: "ifscCode",
			type: "text",
			placeholder: "Enter IFSC Code",
			label: "* IFSC Code",
			value: formData?.ifscCode,
			required: true,
		},
		{
			id: 5,
			error: error?.accountNumber,
			field: "accountNumber",
			type: "text",
			placeholder: "Enter Account Number",
			label: "* Account Number",
			value: formData?.accountNumber,
			required: true,
		},
		{
			id: 6,
			error: error?.upiId,
			field: "upiId",
			type: "text",
			placeholder: "Enter UPI Id",
			label: "* UPI Id",
			value: formData?.upiId,
			required: true,
		},
		{
			id: 7,
			error: error?.netBankingId,
			field: "netBankingId",
			type: "text",
			placeholder: "Enter Net banking Id",
			label: "* Net banking Id",
			value: formData?.netBankingId,
			required: true,
		},
		{
			id: 8,
			error: error?.netBankingPassword,
			field: "netBankingPassword",
			type: "text",
			placeholder: "Enter Net banking Password",
			label: "* Net banking Password",
			value: formData?.netBankingPassword,
			required: true,
		},
		{
			id: 9,
			error: error?.openingBalance,
			field: "openingBalance",
			type: "text",
			placeholder: "Enter Opening Balance",
			label: "* Opening Balance",
			value: formData?.openingBalance,
			required: true,
		},
		{
			id: 10,
			error: error?.nameOnCard,
			field: "nameOnCard",
			type: "text",
			placeholder: "Enter Name On Card",
			label: "* Name On Card",
			value: formData?.nameOnCard,
			required: true,
		},
		{
			id: 11,
			error: error?.cardNumber,
			field: "cardNumber",
			type: "text",
			placeholder: "0000-0000-0000-0000",
			label: "* Card Number",
			value: formData?.cardNumber,
			required: true,
		},
		{
			id: 12,
			error: error?.csvNumber,
			field: "csvNumber",
			type: "text",
			placeholder: "000",
			label: "* CVV Number",
			value: formData?.csvNumber,
			required: true,
		},
		{
			id: 13,
			error: error?.expirerOn,
			field: "expirerOn",
			type: "text",
			placeholder: "MM/YY",
			label: "* Expire On",
			value: formData?.expirerOn,
			required: true,
		},
		{
			id: 14,
			error: error?.pinNumber,
			field: "pinNumber",
			type: "text",
			placeholder: "0000",
			label: "* PIN Number",
			value: formData?.pinNumber,
			required: true,
		},
		{
			id: 15,
			error: error?.ledgerId,
			field: "ledgerId",
			type: "singleSelect",
			label: "Select Ledger",
			placeholder: "Select Ledger",
			value: formData?.ledgerId,
			options: ledgerOptions || [],
			required: false,
		},
	];
};

const debitCategoryForm = ({ error, formData }) => {
	return [
		{
			id: 1,
			error: error?.categoryName,
			field: "categoryName",
			type: "text",
			placeholder: "Enter Payment Category Name",
			label: "* Payment Category Name",
			value: formData?.categoryName,
			required: true,
		},
	];
};

const creditCategoryForm = ({ error, formData }) => {
	return [
		{
			id: 1,
			error: error?.categoryName,
			field: "categoryName",
			type: "text",
			placeholder: "Enter Receipt Category Name",
			label: "* Receipt Category Name",
			value: formData?.categoryName,
			required: true,
		},
	];
};

const crDrMenu = [
	{
		pathname: "/accounting/bank-transfer",
		pageName: "Contra",
		image: creditCardIcon,
	},
];

const staffNoteMenu = [
	{
		pathname: "/accounting/staff-debit-note",
		pageName: "Staff Debit Note",
		image: creditCardIcon,
	},
	{
		pathname: "/accounting/staff-credit-note",
		pageName: "Staff Credit Note",
		image: creditCardIcon,
	},
];

const CrDrForm = ({ error, formData, bankAccounts, ledgerOptions }) => {
	return [
		{
			id: 4,
			error: error?.accountId,
			field: "accountId",
			type: "singleSelect",
			placeholder: "Select Ledger",
			label: "* Select Ledger (Debit)",
			value: formData?.accountId,
			required: true,
			options: [
				{ value: "", label: "Select Ledger" },
				...(bankAccounts?.length > 0
					? bankAccounts.map((item) => ({
						value: item._id,
						label: item.name || item.bankName,
					}))
					: []),
			],
		},
		{
			id: 1,
			error: error?.transactionDate,
			field: "transactionDate",
			type: "datepicker",
			placeholder: "DD-MM-YYYY",
			label: "* Select Date",
			value: formData?.transactionDate,
			required: true,
			icon: captionIcon,
		},
		{
			id: 2,
			error: error?.amount,
			field: "amount",
			type: "text",
			placeholder: "Enter Amount",
			label: "* Amount",
			value: formData?.amount,
			required: true,
			icon: rupeeIcon,
		},
		{
			id: 5,
			error: error?.ledgerId,
			field: "ledgerId",
			type: "singleSelect",
			placeholder: "Select Ledger",
			label: "* Select Ledger (Credit)",
			value: formData?.ledgerId,
			required: true,
			options: [
				{ value: "", label: "Select Ledger" },
				...(ledgerOptions || []),
			],
		},
		{
			id: 3,
			error: error?.title,
			field: "title",
			type: "text",
			placeholder: "Enter Description",
			label: "Description",
			value: formData?.title,
			required: false,
			icon: rupeeIcon,
		},
	];
};

const StaffCrDrForm = ({ error, formData, bankAccounts }) => {
	return [
		{
			id: 4,
			error: error?.accountId,
			field: "accountId",
			type: "singleSelect",
			placeholder: "Select Bank / Cash Account",
			label: "* Select Bank / Cash Account",
			value: formData?.accountId,
			required: true,
			options: [
				{ value: "", label: "Select Bank / Cash Account" },
				...(bankAccounts?.length > 0
					? bankAccounts.map((item) => ({
						value: item._id,
						label: item.name || item.bankName,
					}))
					: []),
			],
		},
		{
			id: 1,
			error: error?.transactionDate,
			field: "transactionDate",
			type: "datepicker",
			placeholder: "DD-MM-YYYY",
			label: "* Select Date",
			value: formData?.transactionDate,
			required: true,
			icon: captionIcon,
		},
		{
			id: 2,
			error: error?.amount,
			field: "amount",
			type: "text",
			placeholder: "Enter Amount",
			label: "* Amount",
			value: formData?.amount,
			required: true,
			icon: rupeeIcon,
		},
		{
			id: 3,
			error: error?.title,
			field: "title",
			type: "text",
			placeholder: "Enter Description",
			label: "Description",
			value: formData?.title,
			required: false,
			icon: rupeeIcon,
		},
	];
};

const siteSettingForm = ({ error, formData }) => {
	return [
		{
			id: 1,
			error: error?.serviceCharge,
			field: "serviceCharge",
			type: "text",
			placeholder: "Attraction/Package Service Charge (in %)",
			label: "* Attraction/Package Service Charge (in %)",
			value: formData?.serviceCharge,
			required: true,
		},
		{
			id: 2,
			error: error?.maxVisitorAllow,
			field: "maxVisitorAllow",
			type: "text",
			placeholder: "Enter How much visitor allow in booking?",
			label: "* How much visitor allow in booking?",
			value: formData?.maxVisitorAllow,
			required: true,
		},
		{
			id: 3,
			error: error?.loginSouOtp,
			field: "loginSouOtp",
			type: "toggle-checkbox",
			placeholder: "",
			label: "Login SOU OTP",
			value: formData?.loginSouOtp,
			required: false,
		},
	];
};

const serviceChargeByDateForm = ({ error, formData }) => {
	return [
		{
			id: 1,
			error: error?.startDate,
			field: "startDate",
			type: "datepicker",
			placeholder: "DD-MM-YYYY",
			label: "* Start Date",
			value: formData?.startDate,
			required: true,
			icon: captionIcon,
		},
		{
			id: 2,
			error: error?.endDate,
			field: "endDate",
			type: "datepicker",
			placeholder: "DD-MM-YYYY",
			label: "* End Date",
			value: formData?.endDate,
			required: true,
			icon: captionIcon,
		},
		{
			id: 3,
			error: error?.serviceCharge,
			field: "serviceCharge",
			type: "text",
			placeholder: "Attraction/Package Service Charge (in %)",
			label: "* Service Charge (in %)",
			value: formData?.serviceCharge,
			required: true,
			icon: rupeeIcon,
		},
		{
			id: 4,
			error: error?.note,
			field: "note",
			type: "text",
			placeholder: "Enter Note (Optional)",
			label: "Note",
			value: formData?.note,
			required: false,
			icon: captionIcon,
		},
	];
};

const reportMenu = [
	{
		pathname: "/reports/sales",
		pageName: "Sales",
		image: salesIcon,
	},
	{
		pathname: "/reports/offline-sales",
		pageName: "Offline Sales",
		image: salesIcon,
	},
	{
		pathname: "/reports/purchase",
		pageName: "Purchase",
		image: purchaseIcon,
	},
	{
		pathname: "/reports/commission",
		pageName: "Commission",
		image: commissionIcon,
	},
	{
		pathname: "/reports/cancel",
		pageName: "Cancel",
		image: cancelIcon,
	},
	{
		pathname: "/reports/refund",
		pageName: "Refund",
		image: refundSecondIcon,
	},
	{
		pathname: "/reports/gst",
		pageName: "GST",
		image: gstIcon,
	},
];

const homeBannerForm = ({ error, formData }) => {
	return [
		{
			id: 1,
			error: error?.title,
			field: "title",
			type: "text",
			placeholder: "Banner Title",
			label: "Banner Title",
			value: formData?.title,
			required: false,
		},
		{
			id: 2,
			error: error?.url,
			field: "url",
			type: "text",
			placeholder: "URL",
			label: "URL",
			value: formData?.url,
			required: false,
		},
		{
			id: 3,
			error: error?.imageAltTag,
			field: "imageAltTag",
			type: "text",
			placeholder: "Image Alt Tag",
			label: "Image Alt Tag",
			value: formData?.imageAltTag,
			required: false,
		},
	];
};

const homePlaceForm = ({ error, formData, Place }) => {
	return [
		{
			id: 1,
			error: error?.placeId,
			field: "placeId",
			type: "select",
			placeholder: "",
			label: "Select Place For Home Page",
			value: formData?.placeId,
			required: true,
			options: [
				{ value: "", label: "Select Place" },
				...(Place?.length > 0
					? Place.map((item) => ({
						value: item._id,
						label: item.name,
					}))
					: []),
			],
		},
		{
			id: 2,
			error: error?.imageAltTag,
			field: "imageAltTag",
			type: "text",
			placeholder: "Image Alt Tag",
			label: "Image Alt Tag",
			value: formData?.imageAltTag,
			required: false,
		},
	];
};

const phoneNumberForm = ({ error, formData }) => {
	return [
		{
			id: 1,
			error: error?.phoneNumber,
			field: "phoneNumber",
			type: "text",
			placeholder: "Enter SOU Phone Number",
			label: "SOU Phone Number",
			value: formData?.phoneNumber,
			required: false,
		},
	];
};

const bankAccessForm = ({
	error,
	formData,
	teamOptions,
	bankAccountOption,
}) => {
	return [
		{
			id: 1,
			error: error?.assignDate,
			field: "assignDate",
			type: "datepicker",
			placeholder: "DD-MM-YYYY",
			label: "Select Date",
			value: formData?.assignDate,
			required: true,
			icon: captionIcon,
		},
		{
			id: 2,
			error: error?.staffId,
			field: "staffId",
			type: "select",
			placeholder: "staffId",
			value: formData?.staffId,
			label: "* Select Employee",
			options: teamOptions,
			required: true,
		},
		{
			id: 3,
			error: error?.accountId,
			field: "accountId",
			type: "select",
			placeholder: "accountId",
			value: formData?.accountId,
			label: "* Select Bank",
			options: bankAccountOption,
			required: true,
		},
		{
			id: 4,
			error: error?.openingBalance,
			field: "openingBalance",
			type: "text",
			placeholder: "0",
			value: formatToINR(formData?.openingBalance),
			label: "* Available Balance",
			required: true,
			readOnly: true,
		},
		{
			id: 5,
			error: error?.actualOpeningBalance,
			field: "actualOpeningBalance",
			type: "text",
			placeholder: "0",
			value: formData?.actualOpeningBalance,
			label: "* Actual Opening Balance",
			required: true,
		},
	];
};

const salesReportMenu = [
	{
		pathname: "/accounting/reports/sales/attraction",
		pageName: "Attraction",
	},
	{
		pathname: "/accounting/reports/sales/package",
		pageName: "Package",
	},
	{
		pathname: "/accounting/reports/sales/booking",
		pageName: "Booking",
	},
];

const bankTransferForm = ({ error, formData, bankAccounts }) => {
	return [
		{
			id: 1,
			error: error?.transactionDate,
			field: "transactionDate",
			type: "datepicker",
			placeholder: "DD-MM-YYYY",
			label: "Select Date",
			value: formData?.transactionDate,
			required: true,
			icon: captionIcon,
		},
		{
			id: 2,
			error: error?.amount,
			field: "amount",
			type: "text",
			placeholder: "Enter Amount",
			label: "Amount",
			value: formData?.amount,
			required: true,
			icon: rupeeIcon,
		},
		{
			id: 3,
			error: error?.fromAccountId,
			field: "fromAccountId",
			type: "singleSelect",
			placeholder: "Select Account",
			label: "From Account",
			value: formData?.fromAccountId,
			required: true,
			options: [
				{ value: "", label: "Select Account" },
				...(bankAccounts?.length > 0
					? bankAccounts.map((item) => ({
						value: item._id,
						label: item.name || item.bankName,
					}))
					: []),
			],
		},
		{
			id: 4,
			error: error?.toAccountId,
			field: "toAccountId",
			type: "singleSelect",
			placeholder: "Select Account",
			label: "* To Account",
			value: formData?.toAccountId,
			required: true,
			options: [
				{ value: "", label: "Select Account" },
				...(bankAccounts?.length > 0
					? bankAccounts.map((item) => ({
						value: item._id,
						label: item.name || item.bankName,
					}))
					: []),
			],
		},
		{
			id: 5,
			error: error?.title,
			field: "title",
			type: "text",
			placeholder: "Enter Description",
			label: "Description",
			value: formData?.title,
			required: false,
			icon: rupeeIcon,
		},
	];
};

const numberAccessForm = ({
	error,
	formData,
	teamOptions,
	phoneNumberOption,
}) => {
	return [
		{
			id: 1,
			error: error?.assignDate,
			field: "assignDate",
			type: "datepicker",
			placeholder: "DD-MM-YYYY",
			label: "Select Date",
			value: formData?.assignDate,
			required: true,
			icon: captionIcon,
		},
		{
			id: 2,
			error: error?.staffId,
			field: "staffId",
			type: "select",
			placeholder: "staffId",
			value: formData?.staffId,
			label: "* Select Employee",
			options: teamOptions,
			required: true,
		},
		{
			id: 3,
			error: error?.phoneNumberId,
			field: "phoneNumberId",
			type: "select",
			placeholder: "phoneNumberId",
			value: formData?.phoneNumberId,
			label: "* Select Number",
			options: phoneNumberOption,
			required: true,
		},
	];
};

const assignAccountMenu = [
	{
		pathname: "/assign-account/bank",
		pageName: "Bank Account",
		image: bankIcon,
	},
	{
		pathname: "/assign-account/credit-card",
		pageName: "Credit Card",
		image: creditCardIcon,
	},
];

const bankDetailForm = ({ error, formData }) => {
	return [
		{
			id: 1,
			error: error?.accountName,
			field: "accountName",
			type: "text",
			placeholder: "Enter Bank Holder Name",
			label: "* Account Name",
			value: formData?.accountName,
			readOnly: true,
		},
		{
			id: 2,
			error: error?.mobileNumber,
			field: "mobileNumber",
			type: "text",
			placeholder: "Enter Mobile Number",
			label: "* Mobile Number",
			value: formData?.mobileNumber,
			readOnly: true,
		},
		{
			id: 3,
			error: error?.bankName,
			field: "bankName",
			type: "text",
			placeholder: "Enter Bank Name",
			label: "* Bank Name",
			value: formData?.bankName,
			readOnly: true,
		},
		{
			id: 4,
			error: error?.ifscCode,
			field: "ifscCode",
			type: "text",
			placeholder: "Enter IFSC Code",
			label: "* IFSC Code",
			value: formData?.ifscCode,
			readOnly: true,
		},
		{
			id: 5,
			error: error?.accountNumber,
			field: "accountNumber",
			type: "text",
			placeholder: "Enter Account Number",
			label: "* Account Number",
			value: formData?.accountNumber,
			readOnly: true,
		},
		{
			id: 6,
			error: error?.upiId,
			field: "upiId",
			type: "text",
			placeholder: "Enter UPI Id",
			label: "* UPI Id",
			value: formData?.upiId,
			readOnly: true,
		},
		{
			id: 7,
			error: error?.netBankingId,
			field: "netBankingId",
			type: "text",
			placeholder: "Enter Net banking Id",
			label: "* Net banking Id",
			value: formData?.netBankingId,
			readOnly: true,
		},
		{
			id: 8,
			error: error?.netBankingPassword,
			field: "netBankingPassword",
			type: "text",
			placeholder: "Enter Net banking Password",
			label: "* Net banking Password",
			value: formData?.netBankingPassword,
			readOnly: true,
		},
		{
			id: 10,
			error: error?.nameOnCard,
			field: "nameOnCard",
			type: "text",
			placeholder: "Enter Name On Card",
			label: "* Name On Card",
			value: formData?.nameOnCard,
			readOnly: true,
		},
		{
			id: 11,
			error: error?.cardNumber,
			field: "cardNumber",
			type: "text",
			placeholder: "0000-0000-0000-0000",
			label: "* Card Number",
			value: formData?.cardNumber,
			readOnly: true,
		},
		{
			id: 12,
			error: error?.csvNumber,
			field: "csvNumber",
			type: "text",
			placeholder: "000",
			label: "* CVV Number",
			value: formData?.csvNumber,
			readOnly: true,
		},
		{
			id: 13,
			error: error?.expirerOn,
			field: "expirerOn",
			type: "text",
			placeholder: "MM/YY",
			label: "* Expire On",
			value: formData?.expirerOn,
			readOnly: true,
		},
		{
			id: 14,
			error: error?.pinNumber,
			field: "pinNumber",
			type: "text",
			placeholder: "0000",
			label: "* PIN Number",
			value: formData?.pinNumber,
			readOnly: true,
		},
	];
};

const creditCardDetailForm = ({ error, formData }) => {
	return [
		{
			id: 1,
			error: error?.accountName,
			field: "accountName",
			type: "text",
			placeholder: "Enter Bank Holder Name",
			label: "* Account Name",
			value: formData?.accountName,
			readOnly: true,
		},
		{
			id: 2,
			error: error?.mobileNumber,
			field: "mobileNumber",
			type: "text",
			placeholder: "Enter Mobile Number",
			label: "* Mobile Number",
			value: formData?.mobileNumber,
			readOnly: true,
		},
		{
			id: 3,
			error: error?.bankName,
			field: "bankName",
			type: "text",
			placeholder: "Enter Bank Name",
			label: "* Bank Name",
			value: formData?.bankName,
			readOnly: true,
		},
		{
			id: 4,
			error: error?.openingBalance,
			field: "openingBalance",
			type: "text",
			placeholder: "Enter Opening Balance",
			label: "* Opening Balance",
			value: formData?.openingBalance,
			readOnly: true,
		},
		{
			id: 5,
			error: error?.nameOnCard,
			field: "nameOnCard",
			type: "text",
			placeholder: "Enter Name On Card",
			label: "* Name On Card",
			value: formData?.nameOnCard,
			readOnly: true,
		},
		{
			id: 6,
			error: error?.cardNumber,
			field: "cardNumber",
			type: "text",
			placeholder: "0000-0000-0000-0000",
			label: "* Card Number",
			value: formData?.cardNumber,
			readOnly: true,
		},
		{
			id: 7,
			error: error?.csvNumber,
			field: "csvNumber",
			type: "text",
			placeholder: "000",
			label: "* CVV Number",
			value: formData?.csvNumber,
			readOnly: true,
		},
		{
			id: 8,
			error: error?.expirerOn,
			field: "expirerOn",
			type: "text",
			placeholder: "MM/YY",
			label: "* Expire On",
			value: formData?.expirerOn,
			readOnly: true,
		},
		{
			id: 9,
			error: error?.pinNumber,
			field: "pinNumber",
			type: "text",
			placeholder: "0000",
			label: "* PIN Number",
			value: formData?.pinNumber,
			readOnly: true,
		},
	];
};

const upcomingAttractionBookingMenu = [
	{
		pathname: "/upcoming_booking?booking_type=upcoming&type=progress",
		pageName: "All Upcoming",
		image: pendingBooking,
	},
	{
		pathname: "/upcoming_booking?booking_type=upcoming&type=confirm",
		pageName: "Confirm Upcoming",
		image: todayBooking,
	},
	{
		pathname: "/upcoming_booking?booking_type=upcoming&type=reject",
		pageName: "Reject",
		image: todayBooking,
	},
];

const upcomingConfirmForm = ({ error, formData, bankAccounts }) => {
	return [
		{
			id: 1,
			error: error?.accountId,
			field: "accountId",
			type: "select",
			placeholder: "",
			label: "* Select Bank Account",
			value: formData?.accountId,
			required: true,
			options: [
				{ value: "", label: "Select Bank" },
				...(bankAccounts?.length > 0
					? bankAccounts.map((item) => ({
						value: item._id,
						label: item.bankName,
					}))
					: []),
			],
		},
		{
			id: 2,
			error: error?.amount,
			field: "amount",
			type: "text",
			placeholder: "Enter Amount",
			label: "* Amount",
			value: formData?.amount,
			required: true,
			icon: rupeeIcon,
		},
	];
};

const upcomingRejectForm = ({ formData }) => {
	return [
		{
			id: 1,
			field: "upcomingRejectionNote",
			type: "textarea",
			placeholder: "Enter Note",
			label: "Note",
			value: formData?.upcomingRejectionNote,
		},
	];
};

const cancelConfirmForm = ({ error, formData, bankAccounts }) => {
	return [
		{
			id: 1,
			error: error?.accountId,
			field: "accountId",
			type: "select",
			placeholder: "",
			label: "* Select Bank Account",
			value: formData?.accountId,
			required: true,
			options: [
				{ value: "", label: "Select Bank" },
				...(bankAccounts?.length > 0
					? bankAccounts.map((item) => ({
						value: item._id,
						label: item.bankName,
					}))
					: []),
			],
		},
		{
			id: 2,
			error: error?.amount,
			field: "amount",
			type: "text",
			placeholder: "Enter Amount",
			label: "* SOU Refund Amount",
			value: formData?.amount,
			required: true,
			icon: rupeeIcon,
		},
		{
			id: 3,
			error: error?.refundReason,
			field: "refundReason",
			type: "textarea",
			placeholder: "Enter Refund Reason",
			label: `* Refund Reason (${formData?.cancelBy ? 'Cancel By User' : 'Cancel By Admin'})`,
			value: formData?.refundReason,
			required: true,
		},
		{
			id: 4,
			error: error?.bankDetail,
			field: "bankDetail",
			type: "textarea",
			placeholder: "Enter Bank Detail/UPI Id",
			label: "* Customer Bank Detail/UPI Id",
			value: formData?.bankDetail,
			required: true,
		},
	];
};

const quotationMenu = [
	{
		pathname: "/quotations/pending",
		pageName: "Pending",
		image: pendingBooking,
	},
	{
		pathname: "/quotations/confirm",
		pageName: "Confirm",
		image: todayBooking,
	},
	{
		pathname: "/quotations/reject",
		pageName: "Reject",
		image: todayBooking,
	},
];

const customerQuotations = ({
	error,
	formData,
	attraction,
	Place,
	Package,
	daysArray,
}) => {
	return [
		{
			id: 1,
			error: error?.customerFirstName,
			field: "customerFirstName",
			type: "text",
			placeholder: "Enter Customer First Name",
			label: "Customer First Name",
			value: formData?.customerFirstName,
			required: true,
		},
		{
			id: 2,
			error: error?.customerLastName,
			field: "customerLastName",
			type: "text",
			placeholder: "Enter Customer Last Name",
			label: "Customer Last Name",
			value: formData?.customerLastName,
			required: true,
		},
		{
			id: 3,
			error: error?.totalVisitor,
			field: "totalVisitor",
			type: "text",
			placeholder: "Enter Total Adult Visitor",
			label: "Total Adult Visitor",
			value: formData?.totalVisitor,
			required: true,
		},
		{
			id: 4,
			error: error?.phoneNo,
			field: "phoneNo",
			type: "text",
			placeholder: "Enter mobile number",
			label: "Mobile Number",
			value: formData?.phoneNo,
			required: true,
		},
		{
			id: 5,
			error: error?.email,
			field: "email",
			type: "text",
			placeholder: "Enter Email ID",
			label: "Email ID",
			value: formData?.email,
			required: true,
			icon: emailIcon,
		},
		{
			id: 6,
			error: error?.address,
			field: "address",
			type: "textarea",
			placeholder: "Enter Address",
			label: "Customer Address",
			value: formData?.address,
			required: true,
		},
		{
			id: 7,
			field: "placeId",
			type: "singleSelect",
			placeholder: "",
			label: "",
			value: attraction?.placeId,
			required: true,
			options: [
				{ value: "", label: "Select Place" },
				...(Place?.length > 0
					? Place.filter((item) => !item.isHotelPlace)
						.map((item) => ({
							value: item._id,
							label: item.name,
						}))
					: []),
			],
		},
		{
			id: 8,
			field: "visitingDate",
			type: "datepicker",
			placeholder: "DD-MM-YYYY",
			value: attraction?.visitingDatePicker,
			required: true,
			icon: captionIcon,
		},
		{
			id: 9,
			field: "attractionSlotId",
			type: "select",
			placeholder: "",
			label: "",
			value: attraction?.attractionSlotId,
			required: true,
			options: [
				{ value: "", label: "Select Slot" },
				...(attraction?.slotOptions || []),
			],
		},
		{
			id: 10,
			field: "adult",
			type: "text",
			placeholder: "Unit / Adult",
			value: attraction?.adult,
			required: true,
		},
		{
			id: 15,
			field: "child",
			type: "text",
			placeholder: "Child",
			value: attraction?.child,
			required: true,
		},
		{
			id: 11,
			field: "fromTime",
			type: "timeSearchPicker",
			placeholder: "From Time",
			value: attraction?.fromTimePicker,
			required: true,
		},
		{
			id: 12,
			field: "toTime",
			type: "timeSearchPicker",
			placeholder: "To Time",
			value: attraction?.toTimePicker,
			required: true,
		},
		{
			id: 13,
			field: "day",
			type: "select",
			placeholder: "",
			label: "",
			value: attraction?.day,
			required: true,
			options: daysArray,
		},
		{
			id: 14,
			field: "packageId",
			type: "singleSelect",
			placeholder: "",
			label: "",
			value: formData?.packageId,
			required: true,
			options: [
				{ value: "", label: "Select Package" },
				...(Package?.length > 0
					? Package.map((item) => ({
						value: item._id,
						label: item.packageNumber + ": " + item.name,
					}))
					: []),
			],
		},
		{
			id: 15,
			error: error?.totalChildVisitor,
			field: "totalChildVisitor",
			type: "text",
			placeholder: "Enter Total Child Visitor",
			label: "Total Child Visitor",
			value: formData?.totalChildVisitor,
			required: false,
		},
		{
			id: 16,
			field: "quotationStartDate",
			type: "datepicker",
			placeholder: "DD-MM-YYYY",
			value: formData?.quotationStartDate,
			label: "Quotation Date",
			required: true,
			icon: captionIcon,
		},
	];
};

const addVisitorForm = ({ error, visitor, Countries }) => {
	return [
		{
			id: 1,
			error: error?.firstName,
			field: "firstName",
			type: "text",
			placeholder: "Enter Visitor Name",
			label: "Visitor Name",
			value: visitor?.firstName,
			required: true,
		},
		{
			id: 2,
			error: error?.gender,
			field: "gender",
			type: "select",
			label: "Gender",
			value: visitor?.gender,
			required: true,
			options: [
				{ value: "0", label: "Select Visitor Gender" },
				{ value: "Male", label: "Male" },
				{ value: "Female", label: "Female" },
			],
		},
		{
			id: 3,
			error: error?.age,
			field: "age",
			type: "text",
			label: "Age",
			value: visitor?.age,
			required: true,
			placeholder: "Enter Visitor Age",
		},
		{
			id: 4,
			error: error?.countryId,
			field: "countryId",
			type: "select",
			label: "Country",
			value: visitor?.countryId,
			required: true,
			options: [
				{ value: "", label: "Select Country" },
				...(Countries?.length > 0
					? Countries.map((item) => ({
						value: item.countryId,
						label: item.name,
					}))
					: []),
			],
		},
		{
			id: 5,
			error: error?.stateId,
			field: "stateId",
			type: "select",
			label: "State",
			value: visitor?.stateId,
			required: true,
			options: [],
		},
	];
};

const bookingHistoryMenu = [
	{
		pathname: "/attraction-booking-history/all",
		pageName: "All Booking",
		image: todayBooking,
	},
	{
		pathname: "/attraction-booking-history/pending",
		pageName: "Pending Booking",
		image: pendingBooking,
	},
	{
		pathname: "/attraction-booking-history/upcoming",
		pageName: "Upcoming Booking",
		image: upcomingBooking,
	},
	{
		pathname: "/attraction-booking-history/confirm",
		pageName: "Confirm Booking",
		image: confirmBooking,
	},
	{
		pathname: "/attraction-booking-history/offline",
		pageName: "Offline Booking",
		image: offlineBooking,
	},
	{
		pathname: "/attraction-booking-history/agent",
		pageName: "Agent",
		image: userIcon,
	},
	{
		pathname: "/attraction-booking-history/cancel",
		pageName: "Cancel Booking",
		image: totalBooking,
	},
	{
		pathname: "/attraction-booking-history/specific-cancel",
		pageName: "Specific Cancel",
		image: todayVisitor,
	},
	{
		pathname: "/attraction-booking-history/refund",
		pageName: "Refund Booking",
		image: todayVisitor,
	},
];

const archiveHistoryMenu = [
	{
		pathname: "/attraction-booking-history/archive",
		pageName: "All Booking",
		image: todayBooking,
	},
	{
		pathname: "/attraction-booking-history/archive?type=confirm",
		pageName: "Confirm Booking",
		image: confirmBooking,
	},
	{
		pathname: "/attraction-booking-history/archive?type=refund",
		pageName: "Refund Booking",
		image: todayVisitor,
	},
];

const packageBookingHistoryMenu = [
	{
		pathname: "/package-booking-history/all",
		pageName: "All Booking",
		image: todayBooking,
	},
	{
		pathname: "/package-booking-history/pending",
		pageName: "Pending Booking",
		image: pendingBooking,
	},
	{
		pathname: "/package-booking-history/upcoming",
		pageName: "Upcoming Booking",
		image: upcomingBooking,
	},
	{
		pathname: "/package-booking-history/confirm",
		pageName: "Confirm Booking",
		image: confirmBooking,
	},
	{
		pathname: "/package-booking-history/offline",
		pageName: "Offline Booking",
		image: offlineBooking,
	},
	{
		pathname: "/package-booking-history/cancel",
		pageName: "Cancel Booking",
		image: totalBooking,
	},
	{
		pathname: "/package-booking-history/specific-cancel",
		pageName: "Specific Cancel",
		image: todayVisitor,
	},
	{
		pathname: "/package-booking-history/refund",
		pageName: "Refund Booking",
		image: todayVisitor,
	},
];

const teamReportForm = ({ error, formData, teamOptions }) => {
	return [
		{
			id: 1,
			error: error?.assignDate,
			field: "assignDate",
			type: "datepicker",
			placeholder: "DD-MM-YYYY",
			label: "Select Date",
			value: formData?.assignDate,
			required: true,
			icon: captionIcon,
		},
		{
			id: 2,
			error: error?.staffId,
			field: "staffId",
			type: "select",
			placeholder: "staffId",
			value: formData?.staffId,
			label: "* Select Employee",
			options: teamOptions,
			required: false,
		},
	];
};

const packageGalleryMenu = [
	{
		pathname: "/package/images",
		pageName: "Images",
		image: SOUiconTwo,
	},
	{
		pathname: "/package/videos",
		pageName: "Videos",
		image: SOUiconTwo,
	},
	{
		pathname: "/package/reels",
		pageName: "Reels",
		image: SOUiconTwo,
	},
];

const enquiryMenu = [
	{
		pathname: "/enquiry/pending",
		pageName: "Enquiry",
		image: packageIcon,
	},
	{
		pathname: "/enquiry/confirm",
		pageName: "Completed",
		image: packageIcon,
	},
];

const addEnquiry = ({ error, formData }) => {
	return [
		{
			id: 1,
			error: error?.name,
			field: "name",
			type: "text",
			placeholder: "Name",
			label: "Name",
			value: formData?.name,
			readOnly: true,
		},
		{
			id: 2,
			error: error?.email,
			field: "email",
			type: "text",
			placeholder: "email",
			label: "Email",
			value: formData?.email,
			readOnly: true,
		},
		{
			id: 4,
			error: error?.phoneNo,
			field: "phoneNo",
			type: "text",
			placeholder: "Phone Number",
			label: "Phone Number",
			value: formData?.phoneNo,
			readOnly: true,
		},
		{
			id: 5,
			error: error?.message,
			field: "message",
			type: "textarea",
			placeholder: "Message",
			label: "Message",
			value: formData?.message,
			readOnly: true,
		},
		{
			id: 6,
			error: error?.staffNote,
			field: "staffNote",
			type: "textarea",
			placeholder: "Staff Note",
			label: "Staff Note",
			value: formData?.staffNote,
		},
		{
			id: 7,
			error: error?.enquiryStatus,
			field: "enquiryStatus",
			type: "select",
			placeholder: "enquiryStatus",
			value: formData?.enquiryStatus,
			label: "Status",
			options: [
				{ value: "0", label: "Select Enquiry Status" },
				{ value: "enquiry", label: "Pending" },
				{ value: "complete", label: "Complete" },
			],
		},
	];
};

const homeNoteForm = ({ error, formData }) => {
	return [
		{
			id: 1,
			error: error?.homepageNoteSwitch,
			field: "homepageNoteSwitch",
			type: "toggle-checkbox",
			placeholder: "",
			label: "Home Note On/Off",
			value: formData?.homepageNoteSwitch,
			required: false,
		},
		{
			id: 2,
			error: error?.homepageNote,
			field: "homepageNote",
			type: "textarea",
			placeholder: "Home page note",
			label: "Home page note",
			value: formData?.homepageNote,
			required: false,
		},
	];
};

const faqForm = ({ error, formData }) => {
	return [
		{
			id: 1,
			error: error?.question,
			field: "question",
			type: "text",
			placeholder: "Enter Question",
			label: "Question",
			value: formData?.question,
			required: false,
		},
		{
			id: 2,
			error: error?.answer,
			field: "answer",
			type: "reach-textarea",
			placeholder: "Enter Answer",
			label: "Answer",
			value: formData?.answer,
			required: false,
		},
	];
};

const eRikshawBookingMenu = [
	{
		pathname: "/rikshaw/e-rikshaw-pending",
		pageName: "Pending",
		image: todayBooking,
	},
	{
		pathname: "/rikshaw/e-rikshaw-today",
		pageName: "Today",
		image: pendingBooking,
	},
	{
		pathname: "/rikshaw/e-rikshaw-confirm",
		pageName: "Confirm",
		image: upcomingBooking,
	},
];

const eRikshawConfirmForm = ({ error, formData, bankAccounts }) => {
	return [
		// {
		// 	id: 1,
		// 	error: error?.accountId,
		// 	field: "accountId",
		// 	type: "select",
		// 	placeholder: "",
		// 	label: "* Select Bank Account",
		// 	value: formData?.accountId,
		// 	required: true,
		// 	options: [
		// 		{ value: "", label: "Select Bank" },
		// 		...(bankAccounts?.length > 0
		// 			? bankAccounts.map((item) => ({
		// 				value: item._id,
		// 				label: item.bankName,
		// 			}))
		// 			: []),
		// 	],
		// },
		{
			id: 1,
			error: error?.eRikshawConfirmDate,
			field: "eRikshawConfirmDate",
			type: "datepicker",
			placeholder: "dd-mm-yyyy",
			label: "* Confirm Date",
			value: formData?.eRikshawConfirmDate,
			required: true,
			icon: captionIcon,
		},
		{
			id: 2,
			error: error?.confirmDate,
			field: "eRikshawConfirmAmount",
			type: "text",
			placeholder: "Enter Amount",
			label: "* Amount",
			value: formData?.eRikshawConfirmAmount,
			required: true,
			icon: rupeeIcon,
		},
	];
};

const addTestimonial = ({ error, formData }) => {
	return [
		{
			id: 1,
			error: error?.name,
			field: "name",
			type: "text",
			placeholder: "Name",
			label: "Name",
			value: formData?.name,
		},
		{
			id: 2,
			error: error?.subTitle,
			field: "subTitle",
			type: "text",
			placeholder: "Sub Title",
			label: "Sub Title",
			value: formData?.subTitle,
		},
		{
			id: 4,
			error: error?.message,
			field: "message",
			type: "textarea",
			placeholder: "Message",
			label: "Message",
			value: formData?.message,
		},
		// {
		//   id: 5,
		//   error: error?.image,
		//   field: "image",
		//   type: "file",
		//   placeholder: "Upload Image",
		//   label: "Image",
		//   value: formData?.image,
		//   required: false,
		//   isOptional: true
		// },
	];
};

const bankAccessMenu = [
	{
		pathname: "/bank-account/access",
		pageName: "Bank Access",
		image: salesIcon,
	},
	{
		pathname: "/bank-account/report",
		pageName: "Bank Report",
		image: purchaseIcon,
	},
];

const staffBankAccessForm = ({
	error,
	formData,
	bankAccountOption,
}) => {
	return [
		{
			id: 1,
			error: error?.accountId,
			field: "accountId",
			type: "select",
			placeholder: "accountId",
			value: formData?.accountId,
			label: "* Select Bank",
			options: bankAccountOption,
			required: true,
		},
		{
			id: 2,
			error: error?.openingBalance,
			field: "openingBalance",
			type: "text",
			placeholder: "0",
			value: formatToINR(formData?.openingBalance),
			label: "* Available Balance",
			required: true,
			readOnly: true,
		},
		{
			id: 3,
			error: error?.actualOpeningBalance,
			field: "actualOpeningBalance",
			type: "text",
			placeholder: "",
			value: formData?.actualOpeningBalance,
			label: "* Actual Opening Balance",
			required: true,
		},
	];
};

const creditCardForm = ({ error, formData }) => {
	return [
		{
			id: 1,
			error: error?.accountName,
			field: "accountName",
			type: "text",
			placeholder: "Enter Bank Holder Name",
			label: "* Account Name",
			value: formData?.accountName,
			required: true,
		},
		{
			id: 2,
			error: error?.mobileNumber,
			field: "mobileNumber",
			type: "text",
			placeholder: "Enter Mobile Number",
			label: "* Mobile Number",
			value: formData?.mobileNumber,
			required: true,
		},
		{
			id: 3,
			error: error?.bankName,
			field: "bankName",
			type: "text",
			placeholder: "Enter Bank Name",
			label: "* Bank Name",
			value: formData?.bankName,
			required: true,
		},
		{
			id: 4,
			error: error?.openingBalance,
			field: "openingBalance",
			type: "text",
			placeholder: "Enter Opening Balance",
			label: "* Opening Balance",
			value: formData?.openingBalance,
			required: true,
		},
		{
			id: 5,
			error: error?.nameOnCard,
			field: "nameOnCard",
			type: "text",
			placeholder: "Enter Name On Card",
			label: "* Name On Card",
			value: formData?.nameOnCard,
			required: true,
		},
		{
			id: 6,
			error: error?.cardNumber,
			field: "cardNumber",
			type: "text",
			placeholder: "0000-0000-0000-0000",
			label: "* Card Number",
			value: formData?.cardNumber,
			required: true,
		},
		{
			id: 7,
			error: error?.csvNumber,
			field: "csvNumber",
			type: "text",
			placeholder: "000",
			label: "* CVV Number",
			value: formData?.csvNumber,
			required: true,
		},
		{
			id: 8,
			error: error?.expirerOn,
			field: "expirerOn",
			type: "text",
			placeholder: "MM/YY",
			label: "* Expire On",
			value: formData?.expirerOn,
			required: true,
		},
		{
			id: 9,
			error: error?.pinNumber,
			field: "pinNumber",
			type: "text",
			placeholder: "0000",
			label: "* PIN Number",
			value: formData?.pinNumber,
			required: true,
		},
	];
};

const accountMainGroupForm = ({ error, formData }) => {
	return [
		{
			id: 1,
			error: error?.name,
			field: "name",
			type: "text",
			placeholder: "Enter Main Group Name",
			label: "* Main Group Name",
			value: formData?.name,
			required: true,
		},
		{
			id: 2,
			error: error?.type,
			field: "type",
			type: "select",
			label: "* Account Type",
			placeholder: "Select Account Type",
			value: formData?.type,
			options: [
				{ value: "", label: "Select Option" },
				{ value: "Liability", label: "Liability" },
				{ value: "Assets", label: "Assets" },
				{ value: "Income", label: "Income" },
				{ value: "Expense", label: "Expense" }
			],
			required: true,
		},
	];
};

const accountSubGroupForm = ({ error, formData, mainGroupOptions }) => {
	return [
		{
			id: 1,
			error: error?.name,
			field: "name",
			type: "text",
			placeholder: "Enter Sub Group Name",
			label: "* Sub Group Name",
			value: formData?.name,
			required: true,
		},
		{
			id: 2,
			error: error?.mainGroup,
			field: "mainGroup",
			type: "singleSelect",
			label: "* Parent Main Group",
			placeholder: "Select Main Group",
			value: formData?.mainGroup,
			options: mainGroupOptions || [],
			required: true,
		},
	];
};

const accountLedgerForm = ({ error, formData, subGroupOptions, stateOptions, isEdit = false }) => {
	const formFields = [
		{
			id: 1,
			error: error?.name,
			field: "name",
			type: "text",
			placeholder: "Enter Ledger Name",
			label: "* Ledger Name",
			value: formData?.name,
			required: true,
		},
		{
			id: 2,
			error: error?.subGroup,
			field: "subGroup",
			type: "singleSelect",
			label: "* Select Group (Main/Sub)",
			placeholder: "Search and Select Group",
			value: formData?.subGroup,
			options: subGroupOptions || [],
			required: true,
		},
		{
			id: 3,
			error: error?.applicable,
			field: "applicable",
			type: "select",
			label: "Applicable",
			placeholder: "Select Applicable Option",
			value: formData?.applicable,
			options: [
				{ value: "None", label: "None" },
				{ value: "GST", label: "GST Rate" },
				{ value: "Company", label: "Mail/Address" },
			],
			required: false,
		},
		{
			id: 12,
			error: error?.financialYear,
			field: "financialYear",
			type: "text",
			placeholder: "1 April 2026",
			label: "Financial Year",
			value: formData?.financialYear || "1 April 2026",
			readOnly: true,
		},
		{
			id: 13,
			error: error?.openingBalance,
			field: "openingBalance",
			type: "number",
			placeholder: "0.00",
			label: "Opening Balance Amount",
			value: formData?.openingBalance,
			readOnly: isEdit,
			required: false,
		},
		{
			id: 14,
			error: error?.openingBalanceType,
			field: "openingBalanceType",
			type: "select",
			label: "Balance Type",
			placeholder: "Select Balance Type",
			value: formData?.openingBalanceType,
			options: [
				{ value: "debit", label: "Debit" },
				{ value: "credit", label: "Credit" },
				{ value: "none", label: "None" }
			],
			readOnly: isEdit,
			required: false,
		},
	];

	if (formData?.applicable === "GST") {
		formFields.push(
			{
				id: 4,
				error: error?.taxPercentage,
				field: "taxPercentage",
				type: "number",
				placeholder: "Enter Tax Percentage",
				label: "Tax Percentage",
				value: formData?.taxPercentage,
				required: false,
			},
			{
				id: 5,
				error: error?.hsnCode,
				field: "hsnCode",
				type: "text",
				placeholder: "Enter HSN/SAE Code",
				label: "HSN/SAE Code",
				value: formData?.hsnCode,
				required: false,
			}
		);
	}

	if (formData?.applicable === "Company") {
		formFields.push(
			{
				id: 6,
				error: error?.companyName,
				field: "companyName",
				type: "text",
				placeholder: "Enter Company Name",
				label: "Company Name",
				value: formData?.companyName,
				required: false,
			},
			{
				id: 7,
				error: error?.address,
				field: "address",
				type: "text",
				placeholder: "Enter Address",
				label: "Address",
				value: formData?.address,
				required: false,
			},
			{
				id: 8,
				error: error?.country,
				field: "country",
				type: "text",
				placeholder: "Enter Country",
				label: "Country",
				value: formData?.country,
				required: false,
			},
			{
				id: 9,
				error: error?.state,
				field: "state",
				type: "singleSelect",
				placeholder: "Select State",
				label: "State",
				value: formData?.state,
				options: stateOptions || [],
				required: false,
			},
			{
				id: 10,
				error: error?.pincode,
				field: "pincode",
				type: "text",
				placeholder: "Enter Pincode",
				label: "Pincode",
				value: formData?.pincode,
				required: false,
			},
			{
				id: 11,
				error: error?.gstDetail,
				field: "gstDetail",
				type: "text",
				placeholder: "Enter GST Detail",
				label: "GST Detail",
				value: formData?.gstDetail,
				required: false,
			}
		);
	}

	return formFields;
};

export {
	userDataSignIn,
	addPlace,
	headerdata,
	bookingOnOff,
	placeOnOff,
	packageMenu,
	bookingMenu,
	bookingDetailMenu,
	siteSettingMenu,
	galleryMenu,
	confirmTicketForm,
	refundForm,
	addMemberForm,
	cancelBookingMenu,
	refundBookingMenu,
	refundBookingForm,
	attendanceForm,
	accountMenu,
	bankAccountForm,
	creditCardForm,
	debitCategoryForm,
	creditCategoryForm,
	packageBookingMenu,
	crDrMenu,
	staffNoteMenu,
	CrDrForm,
	StaffCrDrForm,
	siteSettingForm,
	serviceChargeByDateForm,
	reportMenu,
	homeBannerForm,
	homePlaceForm,
	phoneNumberForm,
	bankAccessForm,
	salesReportMenu,
	bankTransferForm,
	numberAccessForm,
	assignAccountMenu,
	bankDetailForm,
	creditCardDetailForm,
	upcomingAttractionBookingMenu,
	upcomingConfirmForm,
	upcomingRejectForm,
	cancelConfirmForm,
	cancelPackageBookingMenu,
	quotationMenu,
	customerQuotations,
	addVisitorForm,
	refundPackageBookingMenu,
	bookingHistoryMenu,
	archiveHistoryMenu,
	packageBookingHistoryMenu,
	teamReportForm,
	specificRefundBookingMenu,
	packageGalleryMenu,
	enquiryMenu,
	addEnquiry,
	homeNoteForm,
	faqForm,
	eRikshawBookingMenu,
	eRikshawConfirmForm,
	addTestimonial,
	addSitemap,
	bankAccessMenu,
	staffBankAccessForm,
	accountMainGroupForm,
	accountSubGroupForm,
	accountLedgerForm,
	tallyMenu
};

const addSitemap = ({ error, formData }) => {
	return [
		{
			id: 1,
			error: error?.url,
			field: "url",
			type: "text",
			placeholder: "e.g., /blog/my-blog-post or /about-us",
			label: "URL Path",
			value: formData?.url,
		},
		{
			id: 2,
			error: error?.sitemapType,
			field: "sitemapType",
			type: "select",
			placeholder: "Sitemap Type",
			label: "Sitemap Type",
			value: formData?.sitemapType,
			options: [
				{ value: "pages", label: "Pages" },
				{ value: "tickets", label: "Tickets/Places" },
				{ value: "packages", label: "Packages" },
				{ value: "blogs", label: "Blogs" },
				{ value: "hotels", label: "Hotels" },
			],
		},
		{
			id: 3,
			error: error?.changefreq,
			field: "changefreq",
			type: "select",
			placeholder: "Change Frequency",
			label: "Change Frequency",
			value: formData?.changefreq,
			options: [
				{ value: "always", label: "always" },
				{ value: "hourly", label: "hourly" },
				{ value: "daily", label: "daily" },
				{ value: "weekly", label: "weekly" },
				{ value: "monthly", label: "monthly" },
				{ value: "yearly", label: "yearly" },
				{ value: "never", label: "never" },
			],
		},
		{
			id: 4,
			error: error?.priority,
			field: "priority",
			type: "select",
			placeholder: "Priority",
			label: "Priority",
			value: formData?.priority,
			options: [
				{ value: "0.1", label: "0.1" },
				{ value: "0.2", label: "0.2" },
				{ value: "0.3", label: "0.3" },
				{ value: "0.4", label: "0.4" },
				{ value: "0.5", label: "0.5" },
				{ value: "0.6", label: "0.6" },
				{ value: "0.7", label: "0.7" },
				{ value: "0.8", label: "0.8" },
				{ value: "0.9", label: "0.9" },
				{ value: "1.0", label: "1.0" },
			],
		},
	];
};
